export default "__VITE_ASSET__ce6e68b6__"